import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useSnackbar } from "../../contexts/SnackbarContext";
import { useDeleteAllFrames } from "../../hooks/useDevices";

// Deletes ALL frames for one or more devices. There's no bulk delete-all
// endpoint, so this fires one request per device.
export default function ClearFramesDialog({
  deviceIds = [],
  deviceNames = [],
  open,
  handleClose,
}) {
  const deleteAllFramesMutation = useDeleteAllFrames();
  const { showSuccess, showError } = useSnackbar();

  const handleClear = async () => {
    const results = await Promise.allSettled(
      deviceIds.map((id) => deleteAllFramesMutation.mutateAsync(id)),
    );
    const failed = results.filter((r) => r.status === "rejected").length;

    if (failed) {
      showError(
        `Cleared frames for ${deviceIds.length - failed} of ${deviceIds.length} device(s), ${failed} failed`,
      );
    } else {
      showSuccess(
        `Cleared all frames for ${deviceIds.length} device${deviceIds.length === 1 ? "" : "s"}`,
      );
    }
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Clear Frames</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete ALL frames for{" "}
          {deviceIds.length === 1
            ? "this device"
            : `these ${deviceIds.length} devices`}
          ? This cannot be undone.
        </Typography>
        {deviceNames.length > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {deviceNames.join(", ")}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleClear}
          color="error"
          disabled={!deviceIds.length || deleteAllFramesMutation.isPending}
        >
          {deleteAllFramesMutation.isPending ? "Clearing..." : "Clear Frames"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
